import {
    IEmotionCharacterCount,
    resourceNameEmotionCharacterCounts,
} from "motw_core/DTOs/emotioncharactercount";
import { dwkc_oldestDate } from "source/app/presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsChart/DeepWorkKipsChart";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export async function LoadDataAsync() {
    return ClientDataProvider.GetRecordsAsync<IEmotionCharacterCount>(
        `${resourceNameEmotionCharacterCounts}?result_lastmodifieddate=gt.${dwkc_oldestDate}`
    );
}
